import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatPrice(amount: number): string {
  return new Intl.NumberFormat('da-DK', {
    style: 'decimal',
    minimumFractionDigits: 0,
  }).format(amount) + ' kr'
}
